import { createEkSlider } from "./ekSwiperSlider";

export function initProductBulletsSlider(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>("[data-tw-product-bullets-slider]");

  for (const sectionEl of Array.from(sections)) {
    const sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) continue;

    const swiperEl = sectionEl.querySelector<HTMLElement>(".swiper");
    if (!swiperEl) continue;

    createEkSlider({
      sectionEl,
      sectionId,
      swiperEl,
      hasProductCards: false,
      arrowRules: { left: "always", right: "always" },
    });
  }
}
